// extracted by mini-css-extract-plugin
module.exports = {"container":"Logo_container__29KIg","logo":"Logo_logo__3phLi"};